import React from 'react'
import PropTypes from 'prop-types'
import {Box, Button, Flex, Heading, Text, useStyleConfig} from '@chakra-ui/react'
import {Link} from 'react-router-dom'
import {getDamImagePicture} from '../../../custom-hooks/use-dam-image'
import {useGetCategoriesData} from '../../../custom-api/hooks/use-get-categories-data'
import {getGlobalLink, safeBuildUrl} from '../../../utils/contentstack-utils'
import SanitizedHtml from '../../html-sanitizer'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useProducts} from '@salesforce/commerce-sdk-react'

export const PLPBannerPromo = ({heading, bodycopy, image, button}) => {
    const styles = useStyleConfig('PlpBannerPromo')
    const {buildUrl, locale} = useMultiSite()
    const categoriesData = useGetCategoriesData()
    const {data: productsData} = useProducts(
        {
            parameters: {
                ids: button?.productsfcc?.data?.length > 0 ? button.productsfcc.data[0].id : '',
                expand: ['availability', 'images'],
            },
            headers: {
                'x-debug': 'plp-banner-index',
            },
        },
        {
            enabled: button?.productsfcc?.data?.length > 0,
        },
    )
    const {url, label, isAbsolute} = getGlobalLink({
        link: button,
        categoriesData,
        productsData,
        locale: locale?.alias || locale?.id?.toLowerCase(),
    })

    const buttonProps = isAbsolute
        ? {
              as: 'a',
              href: url,
              target: '_blank',
              rel: 'noopener noreferrer',
          }
        : {
              as: Link,
              to: safeBuildUrl(url, buildUrl),
          }

    return (
        <Box data-testid="plp-banner-promo-container" {...styles.container}>
            <Flex {...styles.main}>
                <Box data-testid="plp-banner-promo-image" {...styles.imagebox}>
                    {image && getDamImagePicture(image, image?.alt || '')}
                </Box>
                <Flex {...styles.textblock}>
                    {heading && (
                        <Heading as="h2" data-testid="plp-banner-promo-heading" {...styles.heading}>
                            {heading}
                        </Heading>
                    )}
                    {bodycopy && (
                        <Text>
                            <SanitizedHtml
                                as={Text}
                                html={bodycopy}
                                data-testid="plp-banner-promo-bodycopy"
                                {...styles.bodycopy}
                            />
                        </Text>
                    )}
                    {label && url && (
                        <Button
                            data-testid="plp-banner-promo-button"
                            {...styles.cta}
                            {...buttonProps}
                            variant="outline"
                        >
                            {label}
                        </Button>
                    )}
                </Flex>
            </Flex>
        </Box>
    )
}

PLPBannerPromo.propTypes = {
    heading: PropTypes.string,
    bodycopy: PropTypes.string,
    image: PropTypes.shape(),
    button: PropTypes.shape(),
}
